import { AppForm } from '../../../../../../common/forms/app.form';
import { Injectable } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { ApplicationAppEntityApplicationWrite } from '../../../../../../openapi';

@Injectable()
export class AgreementForm extends AppForm {
  constructor() {
    super({
      regulations: new FormControl(false, { validators: [Validators.requiredTrue], nonNullable: true }),
      clause: new FormControl(false, { validators: [Validators.requiredTrue], nonNullable: true }),
      phoneInformationConsent: new FormControl(null, { validators: [Validators.required] })
    });
  }

  public createPartialTypeExemptionDeclareControl(): void {
    this.addControl('partialTypeExemptionDeclare', new FormControl(false, {
      nonNullable: true,
      validators: [Validators.requiredTrue]
    }));
  }

  public get partialTypeExemptionDeclare(): FormControl | null {
    return this.get('partialTypeExemptionDeclare') as FormControl | null;
  }

  public get electronicCorrespondenceConsent(): FormControl | null {
    return this.get('electronicCorrespondenceConsent') as FormControl | null;
  }

  public createElectronicCorrespondenceConsentControl(): void {
    this.addControl('electronicCorrespondenceConsent', new FormControl(null, Validators.required));
  }

  public toWriteModel(): ApplicationAppEntityApplicationWrite {
    return {
      regulations: this.value.regulations,
      clause: this.value.clause,
      electronicCorrespondenceConsent: this.value.electronicCorrespondenceConsent || null,
      phoneInformationConsent: this.value.phoneInformationConsent
    };
  }
}
